import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Empty State del DS: ícono en círculo (o ilustración de tarjetas) + título + 1 línea + acciones (ng-content). */
@Component({
  selector: 'app-empty-state',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (illustration() === 'cards') {
      <div class="cards" aria-hidden="true">
        <span class="ghost g1"></span><span class="ghost g2"></span>
        <span class="front"><i></i><i></i><b></b><b></b><b></b></span>
        <cr-icon class="spark" name="sparkles" [size]="30" />
      </div>
    } @else {
      <span class="bubble"><cr-icon [name]="icon()" [size]="28" /></span>
    }
    <h2 class="title">{{ title() }}</h2>
    @if (text()) { <p class="text">{{ text() }}</p> }
    <div class="actions"><ng-content /></div>
  `,
  styles: [`
    :host{display:flex;flex-direction:column;align-items:center;text-align:center;gap:12px;padding:24px 16px;max-width:420px;margin:auto}
    .bubble{width:64px;height:64px;border-radius:50%;background:var(--cr-bg-surface-2);display:grid;place-items:center;color:var(--cr-text-primary);margin-bottom:4px}
    .title{font:700 24px/28px var(--cr-font-display);letter-spacing:-.24px;margin:0}
    .text{font:400 15px/22px var(--cr-font-body);color:var(--cr-text-secondary);margin:0}
    .actions{display:flex;flex-direction:column;gap:8px;align-items:center;margin-top:8px}
    .actions:empty{display:none}
    .cards{position:relative;width:260px;height:170px;margin-bottom:8px}
    .ghost{position:absolute;width:200px;height:114px;border-radius:14px;background:var(--cr-bg-surface-2);border:1.5px dashed var(--cr-border-strong)}
    .g1{left:0;top:10px;transform:rotate(-8deg)}
    .g2{right:0;top:0;transform:rotate(7deg)}
    .front{position:absolute;left:30px;top:44px;width:200px;height:114px;border-radius:14px;background:var(--cr-bg-surface);
      box-shadow:var(--cr-elevation-2);display:flex;align-items:center;justify-content:center;gap:8px}
    .front i,.front b{width:18px;height:18px;border-radius:50%;background:var(--cr-brand-teal)}
    .front b{background:var(--cr-bg-surface-2);border:1.5px solid var(--cr-border-strong)}
    .spark{position:absolute;right:12px;top:24px;color:var(--cr-brand-gold)}
    @media (max-width:640px){ :host{padding:16px} .actions{align-self:stretch} }
  `],
})
export class EmptyStateComponent {
  readonly icon = input<string>('info');
  readonly title = input.required<string>();
  readonly text = input<string>('');
  readonly illustration = input<'icon' | 'cards'>('icon');
}
